import {Component, Input, OnInit} from '@angular/core';
import {Constituent} from '../modals/Constituent';
import {PagingModel} from '../shared/pagination-control/PagingModel';
import {ConstituentData} from '../modals/ConstituentData';
import {UtilService} from '../services/UtilService';
import {ColDef} from 'ag-grid-community';

@Component({
  selector: 'app-index-costituent-page',
  templateUrl: './index-costituent-page.component.html',
  styleUrls: ['./index-costituent-page.component.scss']
})
export class IndexCostituentPageComponent implements OnInit {

  constructor(private utilService: UtilService) {
  }

  @Input() constituentData: Constituent[] = [];
  @Input() indexType: any;
  @Input() isTRS = false;
  @Input() expanded = false;
  filterParamsForDate = {
    browserDatePicker: true,
    minValidYear: 1900,
    maxValidYear: 9999,
    comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
      if (cellValue === null) {
        return -1;
      }
      const dateParts = cellValue.split('T')[0].split('-');
      const cellDate = new Date(
        Number(dateParts[0]),
        Number(dateParts[1]) - 1,
        Number(dateParts[2])
      );
      return cellDate.getTime() === filterLocalDateAtMidnight.getTime() ? 0 :
        cellDate.getTime() < filterLocalDateAtMidnight.getTime() ? -1 : 1;
    }
  };

  columnDefs: ColDef[] = [
    {
      headerName: 'Report Date', width: 140, field: 'asOf', tooltipField: 'asOf', hide: true, sortable: true,
      filter: 'agDateColumnFilter', floatingFilter: true,
      valueFormatter: (params: any) => params.value !== null ? params.value.split('T')[0] : params.value,
      filterParams: this.filterParamsForDate
    },
    {
      headerName: 'Rebalance Date', width: 140, field: 'rebalancingDate', tooltipField: 'rebalancingDate', hide: true, sortable: true,
      sort: 'desc', unSortIcon: true, filter: 'agDateColumnFilter', floatingFilter: true,
      valueFormatter: (params: any) => params.value !== null ? params.value.split('T')[0] : params.value,
      filterParams: this.filterParamsForDate
    },
    {headerName: 'Issuer', width: 300, field: 'issuer', hide: true, sortable: true, filter: true, floatingFilter: true},
    {
      headerName: 'Coupon In %', headerTooltip: 'Coupon In %', width: 100, field: 'coupon',
      filter: 'agNumberColumnFilter', floatingFilter: true,
      valueFormatter: (params: any) => params.value === undefined ? '' : params.value.toFixed(4),
      hide: true, sortable: true, comparator: (valueA: number, valueB: number) => valueA - valueB
    },
    {
      headerName: 'Maturity Date', width: 140, field: 'maturityDate', hide: true, sortable: true,
      filter: 'agDateColumnFilter', floatingFilter: true,
      valueFormatter: (params: any) => params.value !== null ? params.value.split('T')[0] : params.value,
      filterParams: this.filterParamsForDate
    },
    {headerName: 'As Of Date', width: 150, field: 'asOfCarbon', hide: true, sortable: true},
    {headerName: 'Name', width: 300, field: 'constituentName', hide: true, sortable: true, filter: true, floatingFilter: false},
    {
      headerName: 'Index Weight in %', width: 140, field: 'indexWeight', sortable: true, hide: true,
      comparator: (valueA: number, valueB: number) => valueA - valueB
    },
    {
      headerName: 'Weight %', width: 140, field: 'weight', sortable: true, hide: true,
      comparator: (valueA: number, valueB: number) => valueA - valueB
    },

  ];
  rowData: ConstituentData[] = [];
  rowDataForUCITS: ConstituentData[] = [];
  pagingInfo: PagingModel = new PagingModel();
  indexGrid: any;
  sortOnColumn = 'rebalancingDate';
  currentOrder = 'DESC';

  ngOnInit(): void {
    this.initPaging();
    this.paginateFilteredData();
    this.displayColumns();
  }

  onGridReady(event: any): void {
    this.indexGrid = event.api;
  }

  populateConstituentDataForIboxx(constituents: any): void {
    this.rowData = [];
    constituents.forEach((constituent: any) => {
      const consttuentData: ConstituentData = new ConstituentData();
      consttuentData.asOf = constituent.asOf;
      // @ts-ignore
      consttuentData.indexWeight = (constituent.indexWeight * 100).toFixed(4);
      if (constituent.assetType === 'futures'){
        consttuentData.coupon = undefined;
        consttuentData.issuer = constituent.level1;
        consttuentData.maturityDate = '';
      }else if (constituent.assetType.includes('swaps')){
        consttuentData.issuer =  constituent.level1;
        consttuentData.coupon = constituent.swapsRebalancing.coupon;
        consttuentData.maturityDate = constituent.swapsRebalancing.maturityDate;
      }else {
        consttuentData.coupon = constituent.bondRebalancing ? constituent.bondRebalancing.coupon : constituent.loanRebalancing.coupon;
        consttuentData.issuer = constituent.bondRebalancing ? constituent.bondRebalancing.issuer : constituent.loanRebalancing.issuer;
        consttuentData.maturityDate = constituent.bondRebalancing ? constituent.bondRebalancing.workoutDate :
        constituent.loanRebalancing.maturityDate;
      }
      consttuentData.rebalancingDate = constituent.rebalancingDate;

      this.rowData.push(consttuentData);
    });
  }

  populateConstituentDataForCarbon(constituents: any): void {
    this.rowData = [];
    constituents.forEach((constituent: any) => {
      const constituentData: ConstituentData = new ConstituentData();
      constituentData.asOfCarbon = (constituent.asOf != null) ? constituent.asOf.split('T')[0] : constituent.asOf;
      // @ts-ignore
      constituentData.indexWeight = (constituent.constituentWeight * 100).toFixed(4);
      constituentData.constituentName = constituent.constituentName;
      this.rowData.push(constituentData);
    });
  }

  populateConstituentDataForEMIX(constituents: any): void {
    this.rowData = [];
    constituents.forEach((constituent: any) => {
      const constituentData: ConstituentData = new ConstituentData();
      constituentData.rebalancingDate = (constituent.asOf != null) ? constituent.asOf.split('T')[0] : constituent.asOf;
      // @ts-ignore
      constituentData.weight = (constituent.constituentWeight * 100).toFixed(4);
      constituentData.constituentName = constituent.constituentName;
      this.rowData.push(constituentData);
    });

    this.rowData.sort((d1: any, d2: any) => d1.weight > d2.weight ? -1 : 1);
  }

  initPaging(): void {
    this.pagingInfo.totalRows = this.constituentData.length;
    this.pagingInfo.pageSize = 10;
    this.pagingInfo.visibleRows = 10;
    this.pagingInfo.totalPages = Math.ceil(this.constituentData.length / this.pagingInfo.pageSize);
  }

  changePage(): void {
    // this.paginateFilteredData();
    this.updatePaging();
    this.indexGrid.paginationGoToPage(this.pagingInfo.page);
    this.indexGrid.paginationSetPageSize(this.pagingInfo.pageSize);
  }

  onFilterChanged(): void {
    this.updatePaging();
  }

  paginateFilteredData(): void {
    if (this.indexType === 'iboxx') {
      this.populateConstituentDataForIboxx(this.constituentData);
    }
    if (this.indexType === 'carbon') {
      this.populateConstituentDataForCarbon(this.constituentData);
    }
    if (this.indexType === 'emix') {
      this.populateConstituentDataForEMIX(this.constituentData);
    }
  }

  updatePaging(): void {
    this.pagingInfo.totalRows = this.indexGrid.getDisplayedRowCount();
    if (isNaN(this.pagingInfo.pageSize)){
      this.pagingInfo.pageSize = this.pagingInfo.totalRows;
      this.indexGrid.setDomLayout('autoHeight');
    }else{
      this.indexGrid.setDomLayout('normal');
    }
    this.pagingInfo.totalPages = Math.ceil(this.pagingInfo.totalRows / this.pagingInfo.pageSize);
  }

  displayColumns(): void {
    let definition = this.columnDefs;
    if (this.indexGrid) {
      definition = this.indexGrid.getColumnDefs();
    }
    definition.forEach((column: any) => {
      switch (column.field) {
        case 'asOf':
          column.hide = this.indexType === 'carbon' || this.indexType === 'emix';
          column.floatingFilter = this.isTRS;
          break;
        case 'rebalancingDate':
          column.hide =  this.indexType === 'carbon';
          column.floatingFilter = this.isTRS;
          break;
        case 'issuer':
          column.hide = this.indexType === 'carbon' || this.indexType === 'emix';
          column.floatingFilter = this.indexType !== 'carbon';
          break;
        case 'coupon':
          column.hide = this.indexType === 'carbon' || this.indexType === 'emix';
          column.floatingFilter = this.indexType !== 'carbon';
          break;
        case 'maturityDate':
          column.hide = this.indexType === 'carbon' || this.indexType === 'emix';
          column.floatingFilter = this.indexType !== 'carbon';
          break;
        case 'asOfCarbon':
          column.hide = this.indexType === 'emix' || this.indexType === 'iboxx';
          break;
        case 'constituentName':
          column.hide = this.indexType === 'iboxx';
          column.floatingFilter = this.indexType === 'emix';
          break;
        case 'weight':
          column.hide = this.indexType === 'carbon' || this.indexType === 'iboxx';
          break;
        case 'indexWeight':
          column.hide = this.indexType === 'emix';
          break;
      }
    });
    this.columnDefs = definition;
  }


  onGridSizeChanged(): void {
    this.displayColumns();
    setTimeout(() => {
      this.utilService.agGridSizeColumnsToFit(this.indexGrid);
    }, 100);
  }

}
